import React from 'react'
import { isObservable, observe } from 'mobx'
import useSmartviewMounter from '../hooks/use-smartview-mounter'
import { ModelContext, useModel, useSelection } from '@morningtrain/react-resources'

function MountSmartviewWithModelOnSelection (props) {
  const model = useModel()

  const smartview = (
    <ModelContext.Provider value={props.model || model}>
      {props.smartview}
    </ModelContext.Provider>
  )

  const mount = useSmartviewMounter(smartview, props.replace, props.keepTreeOnPush)
  const selection = useSelection()

  React.useEffect(() => {
    let disposer = null

    if (isObservable(selection.selected)) {
      disposer = observe(selection.selected, change => {
        if (change.type === 'add') {
          mount({ id: change.newValue })
        }
      })
    }

    return () => {
      if (typeof disposer === 'function') {
        disposer()
      }
    }
  })

  return null
}

MountSmartviewWithModelOnSelection.defaultProps = {
  smartview: null,
  model: null,
  replace: true,
  keepTreeOnPush: false
}

export default MountSmartviewWithModelOnSelection
